import { store } from '@sonifi/wb-core/store/store';
import { initBranding } from '../services/branding.service';
import { initStaycastBranding } from '../services/staycastBranding.service';

export async function loaderBranding({ params }) {
  await store.dispatch(initBranding(parseInt(params.groupId)));
  return {};
}

export async function loaderStaycastBranding({ params }) {
  await store.dispatch(initStaycastBranding(parseInt(params.groupId)));
  return {};
}
